export enum FaixaRendaEnum {
    MENOS_1_SM = "Menos de 1 salário mínimo",
    ATE_2_SM = "Até 2 salários mínimos",
    ATE_3_SM = "Até 3 salários mínimos",
    IGUAL_MAIOR_3_SM = "3 salários mínimos ou mais"
}